import { render, staticRenderFns } from "./iddMovie.vue?vue&type=template&id=d511b326&scoped=true"
import script from "./iddMovie.vue?vue&type=script&lang=js"
export * from "./iddMovie.vue?vue&type=script&lang=js"
import style0 from "./iddMovie.vue?vue&type=style&index=0&id=d511b326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d511b326",
  null
  
)

export default component.exports